import CategoryLink from './components/CategoryLink';
import ContentSection from './components/ContentSection';
import EditableTemplateHeader from './components/EditableTemplateHeader';
import FaqItems from './components/FaqItems';
import PageHeader from './components/PageHeader';
import StickyUseTemplateDesktop from './components/StickyUseTemplateDesktop';
import StickyUseTemplateMobile from './components/StickyUseTemplateMobile';
import { SocialProofSection } from './components/social-proof-section';
export default {
  CategoryLink: CategoryLink,
  ContentSection: ContentSection,
  PageHeader: PageHeader,
  EditableTemplateHeader: EditableTemplateHeader,
  StickyUseTemplateDesktop: StickyUseTemplateDesktop,
  StickyUseTemplateMobile: StickyUseTemplateMobile,
  FaqItems: FaqItems,
  SocialProofSection: SocialProofSection
};